import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { NgxBootstrapMultiselectModule } from 'ngx-bootstrap-multiselect';

import { ClienteAnaliseMercadoStatusPretendidoBadgePillComponent, ClienteAnaliseMercadoStatusPretendidoBadgePillNaoPretendidoComponent, ClienteAnaliseMercadoStatusPretendidoBadgePillPretendidoComponent, ClienteAnaliseMercadoStatusPretendidoBadgePillPotencialComponent, ClienteAnaliseMercadoStatusPretendidoBadgePillRealizadoComponent } from './badge-pill';
import { ClienteAnaliseMercadoStatusPretendidoMultiselectComponent } from './multiselect';

import { ClienteAnaliseMercadoStatusPretendidoPipe } from './pipes';

@NgModule({
    imports: [
        SharedModule,
        NgxBootstrapMultiselectModule
    ],
    declarations: [
        // Badge Pill
        ClienteAnaliseMercadoStatusPretendidoBadgePillComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillNaoPretendidoComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillPretendidoComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillPotencialComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillRealizadoComponent,
        // Multiselect
        ClienteAnaliseMercadoStatusPretendidoMultiselectComponent,

        // Pipes
        ClienteAnaliseMercadoStatusPretendidoPipe
    ],
    exports: [
        SharedModule,

        // Badge Pill
        ClienteAnaliseMercadoStatusPretendidoBadgePillComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillNaoPretendidoComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillPretendidoComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillPotencialComponent,
        ClienteAnaliseMercadoStatusPretendidoBadgePillRealizadoComponent,
        // Multiselect
        ClienteAnaliseMercadoStatusPretendidoMultiselectComponent,

        // Pipes
        ClienteAnaliseMercadoStatusPretendidoPipe
    ],
    providers: [
        // Pipes
        ClienteAnaliseMercadoStatusPretendidoPipe
    ]
})
export class ClienteAnaliseMercadoStatusPretendidoModule { }
